module.exports = __webpack_public_path__ + "img/arrow_right.6d4dc13a.svg";